var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", "text-center": "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-app-bar",
                    { attrs: { color: "primary", flat: "" } },
                    [
                      _c("v-toolbar-title", { staticClass: "text-body-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("components.giftPoints.title")) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-md": "" } },
                    [
                      _vm._l(
                        _vm.filteredErrors,
                        function (errorsGroup, errorsGroupIndex) {
                          return _c(
                            "div",
                            {
                              key: errorsGroupIndex,
                              attrs: {
                                role: "alert",
                                "aria-live": "assertive",
                              },
                            },
                            _vm._l(errorsGroup, function (error) {
                              return _c(
                                "v-alert",
                                {
                                  key: error.id,
                                  attrs: { type: error.type, icon: error.icon },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(error.msg) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min:1|max:36",
                                        expression: "'required|min:1|max:36'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fad fa-helmet-battle",
                                      color: "accent",
                                      "data-vv-as": "character name",
                                      "data-vv-name": "charName",
                                      "error-messages":
                                        _vm.errors.collect("charName"),
                                      label: _vm.$t(
                                        "components.giftPoints.form.receiver"
                                      ),
                                      name: "charName",
                                      type: "search",
                                      "aria-required": "true",
                                      "aria-invalid":
                                        !!_vm.errors.has("charName"),
                                    },
                                    on: { change: _vm.onSearchCharacter },
                                    model: {
                                      value: _vm.form.charName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "charName", $$v)
                                      },
                                      expression: "form.charName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            {
                              attrs: {
                                "two-line": "",
                                "aria-label": "Search Results",
                              },
                            },
                            _vm._l(_vm.charactersList, function (item, index) {
                              return _c(
                                "span",
                                { key: item.account_oid },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: { ripple: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectChar(item.name)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        {
                                          staticClass: "gift-points-char-item",
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "text--accent" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "components.giftPoints.level",
                                                      { years: item.years }
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  index + 1 < _vm.charactersList.length
                                    ? _c("v-divider", { key: index })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min:1|max:90000",
                                        expression:
                                          "'required|min:1|max:90000'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fad fa-coin",
                                      color: "accent",
                                      "data-vv-as": "zushin points",
                                      "data-vv-name": "points",
                                      "error-messages":
                                        _vm.errors.collect("points"),
                                      label: _vm.$t(
                                        "components.giftPoints.form.points"
                                      ),
                                      name: "points",
                                      type: "number",
                                      "aria-required": "true",
                                      "aria-invalid":
                                        !!_vm.errors.has("points"),
                                    },
                                    model: {
                                      value: _vm.form.points,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "points", $$v)
                                      },
                                      expression: "form.points",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-progress-linear", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isLoading,
                                expression: "isLoading",
                              },
                            ],
                            attrs: {
                              color: "accent",
                              indeterminate: "",
                              "aria-hidden": "true",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Send Gift Points",
                                color: "accent",
                                type: "button",
                                disabled: !_vm.hasSelectedChar,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.setDialogVisiblity()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("components.giftPoints.buttons.send")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-dialog",
                            {
                              attrs: {
                                transition: "dialog-bottom-transition",
                                fullscreen: _vm.$vuetify.breakpoint.mdAndDown,
                                width: _vm.$vuetify.breakpoint.mdAndDown
                                  ? "auto"
                                  : "700",
                                role: "dialog",
                                "aria-modal": "true",
                              },
                              model: {
                                value: _vm.isDialogVisible,
                                callback: function ($$v) {
                                  _vm.isDialogVisible = $$v
                                },
                                expression: "isDialogVisible",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-card-title", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.giftPoints.dialog.title"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-card-text", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.giftPoints.dialog.title",
                                            {
                                              points: _vm.form.points,
                                              charName: _vm.form.charName,
                                            }
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("div", { staticClass: "flex-grow-1" }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "aria-label": "Decline Gift Points",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setDialogVisiblity()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.giftPoints.dialog.decline"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "accent--text",
                                          attrs: {
                                            "aria-label": "Confirm Gift Points",
                                            color: "primary",
                                            text: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.validate()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.giftPoints.dialog.confirm"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }